import { AES, enc } from "crypto-js";
import { isValidJSON } from "./cookie";
import Log from "../components/Analytics/Equity/Log";

const dbName = "nuvamaprivate";
const objectStoreName = "table";
const dbVersion = 1;
let db;
const encryptMobx = true;
const secretKey = btoa(process.env.REACT_APP_API_KEY); // Secret key is nothing but base64 conversion of api key.

const dbPromise = new Promise((resolve, reject) => {
  const request = indexedDB.open(dbName, dbVersion);
  request.onerror = (event) => {
    Log("Database error:", event.target.error);
    reject(`Database error ${event.target.error}`);
  };

  request.onsuccess = (event) => {
    db = event.target.result;
    resolve(db);
  };

  request.onblocked = () => {
    reject("Database is blocked");
  };

  request.onupgradeneeded = (event) => {
    const db = event.target.result;
    db.createObjectStore("table", { keyPath: "key" });
  };
}).catch((e) => Log("Error", e));

export function setValue(key, value) {
  return dbPromise
    .then((db) => {
      const tnx = db.transaction(["table"], "readwrite");
      const objectStore = tnx.objectStore("table");

      const encryptedValue = AES.encrypt(
        JSON.stringify(value),
        secretKey
      ).toString();

      objectStore.put({ key, value: encryptMobx ? encryptedValue : value }); // Add or update item
      return tnx.complete;
    })
    .catch((e) => Log("Error", e));
}

export function getValue(key) {
  try {
    return dbPromise
      .then((db) => {
        const tnx = db.transaction(["table"], "readonly");
        const objectStore = tnx.objectStore("table");
        const getRequest = objectStore.get(key);
        return new Promise((resolve, reject) => {
          getRequest.onsuccess = (event) => {
            const value = event.target.result?.value;

            if (encryptMobx) {
              const decrypted = value
                ? AES.decrypt(value, secretKey).toString(enc.Utf8)
                : undefined;
              const parsed = isValidJSON(decrypted)
                ? JSON.parse(decrypted)
                : decrypted;
              resolve(isValidJSON(parsed) ? JSON.parse(parsed) : parsed);
            } else return resolve(value);
          };
          getRequest.onerror = (event) => {
            reject(event.target.error);
          };
        }).catch((e) => Log("Error", e));
      })
      .catch((e) => Log("Error", e));
  } catch (error) {
    Log("Error", error);
  }
}

export function deleteValue(key) {
  // request.onsuccess = (event) => {
  //   db = event.target.result;
  return dbPromise.then((db) => {
    const tnx = db.transaction(["table"], "readwrite");
    const objectStore = tnx.objectStore("table");
    objectStore.delete(key);

    tnx.oncomplete = () => {};
  });
}

export function deleteIndexedDB() {
  indexedDB.deleteDatabase(dbName);
}

export function clearTable(key, value) {
  return dbPromise
    .then((db) => {
      const tnx = db.transaction(["table"], "readwrite");
      const objectStore = tnx.objectStore("table");

      const clearRequest = objectStore.clear();

      clearRequest.onsuccess = () => {
        Log("Object store 'table' cleared successfully.");
        return "Object store 'table' cleared successfully.";
      };

      clearRequest.onerror = (event) => {
        console.error("Error clearing object store:", event.target.error);
        return event.target.error;
      };
    })
    .catch((e) => Log("Error", e));
}

export function doesObjectStoreExist() {
  return dbPromise.then((db) => {
    return new Promise((resolve) => {
      const transaction = db.transaction(objectStoreName);
      transaction.onabort = () => resolve(false);
      transaction.oncomplete = () => resolve(true);
    });
  });
}

// Perform key-value operations
// setValue('myKey', 'myValue'); // Set a key-value pair
// getValue('myKey'); // Get a value by key
// deleteValue('myKdey'); // Delete a value by key
